import './Component/GlobalJQuery'

// Import Twitter Bootstrap v4
//import 'bootstrap'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/tooltip'
import 'bootstrap/js/dist/scrollspy'

// Import webfonts
import 'typeface-roboto'
import 'typeface-nunito-sans'

// Import lazysizes
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'lazysizes/plugins/bgset/ls.bgset'

// Import and initialize medium-zoom
import mediumZoom from 'medium-zoom'
mediumZoom('[data-action="zoom"]')

// Import components
import './Component/FontAwesome'
import './Component/Tooltip'
import './Component/SmoothScroll'

import '../../../../TMSDEV.Blog/Resources/Private/JavaScript/Blog'
import '../../../../TMSDEV.Form/Resources/Private/JavaScript/Form'

// Import styles
import '../Styles/Main.scss'
